import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
  useRouteContext,
  useRouter,
} from '@tanstack/react-router';
import { Button, Flex } from 'antd';
import { Building2, ChartNoAxesColumn, ScrollText, Users, CreditCard } from 'lucide-react';
import { useCallback } from 'react';

import { AccountControl } from '../../../modules/account/components/account-control';
import { signOutWithRevoke } from '../../../modules/auth/sign-out';
import { DashboardLayout } from '../../../ui/components/layout';
import { TopNavigation } from '../../../ui/components/navigation';

const SuperadminLayoutComponent = () => {
  const { account } = useRouteContext({ from: '/_authenticated' });
  const router = useRouter();
  const navigate = useNavigate();
  const pathname = useLocation({ select: (location) => location.pathname });

  const handleSignOut = useCallback(async () => {
    await signOutWithRevoke();
    router.invalidate();
  }, [router]);

  return (
    <DashboardLayout
      header={
        <TopNavigation
          right={
            <Flex align="center" gap={8}>
              <AccountControl
                account={account}
                selectedOrganization={{ id: '', name: 'Super Admin' }}
                settingsTo="/superadmin/settings/profile"
                onSignOut={handleSignOut}
                showNavigationToggle={false}
              />
            </Flex>
          }
        >
          <Flex align="center" gap={6}>
            {[
              { label: 'Organizations', path: '/superadmin/organizations', icon: <Building2 size={17} /> },
              { label: 'Users', path: '/superadmin/users', icon: <Users size={17} /> },
              { label: 'Activity', path: '/superadmin/activity', icon: <ScrollText size={17} /> },
              { label: 'Analytics', path: '/superadmin/analytics', icon: <ChartNoAxesColumn size="1em" /> },
              { label: 'Billing', path: '/superadmin/billing', icon: <CreditCard size={17} /> },
            ].map((item) => (
              <Button
                key={item.path}
                type={pathname === item.path || pathname.startsWith(item.path + '/') ? 'primary' : 'text'}
                icon={item.icon}
                href={item.path}
                onClick={(event) => {
                  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                    return;
                  }
                  event.preventDefault();
                  navigate({ to: item.path });
                }}
                style={{ fontWeight: 500, fontSize: 13, padding: '8px 14px', textDecoration: 'none' }}
              >
                {item.label}
              </Button>
            ))}
          </Flex>
        </TopNavigation>
      }
    >
      <Outlet />
    </DashboardLayout>
  );
};

export const Route = createFileRoute('/_authenticated/superadmin')({
  beforeLoad: ({ context }) => {
    if (context.account?.role !== 'superadmin') {
      throw redirect({ to: '/' });
    }
  },
  component: SuperadminLayoutComponent,
});
